













import DateUtil from '../shared/DateUtil'
import { Component, Prop, Vue, Watch, SaitenState, ConstsState } from 'division-marker';

@Component({components: {}, mixins:[]})
export default class SheetResult extends Vue {
  @Prop() activity: any | null
  get sended(){return this.activity != null}
  get created_at(){ return DateUtil.to_yyyymmdd_hhmmss_slash(this.activity.created_at)}
  get saiten_completed(){
    let limited_at = new Date(this.limited_on);
    limited_at.setHours(17);
    return this.sended && this.activity.saiten_state == 10 && limited_at < new Date()
  }
  get limited_on(){ return DateUtil.to_yyyymmdd_slash(this.activity.limited_on)}
  get pdf_url(){return `./api/branches/answer_image/${this.activity.id}`}

}
